import decimal from 'decimal.js';
import {
  words,
} from './globalState';
import {
  getValidKeyPairs,
  signWithKey,
  getAddressFromKey,
} from './keysAndSigning';
import {
  deleteCart,
  addSendsToTheCartMona,
  buildMonaTransactions,
  confirmCommitMonaTransaction,
  getRegisteredCard,
} from './blockchain';
import {
  setAddressesInCookie,
} from './monacottoMisc';
import {
  syncHttpRequest2,
  devLog,
  decimalAdjust,
} from './utils';

// 「購入:署名」ボタン押下 HANDLE CLICK SIGN PURCHASE
async function handleClickSignPurchase(state, dispatch, cookies, setCookie, addressType, popupLayer ,keyPairs) {
  let addressActual;
  let request = {};
  let messages = {};
  let stateFixed = {};
  let bodyObj = {};

  // state固定
  if (popupLayer !== undefined && popupLayer !== null) {
    stateFixed = {
      purchaseNo: state.purchase.purchaseNo,
      addressMain: state.purchase.addressMain,
      addressPayFrom: state.purchase.addressPayFrom,
      addressSendCardTo: state.purchase.addressSendCardTo,
      addressMainExhibitor: state.popup[popupLayer].body.addressMainExhibitor,
      exhibitNo: state.popup[popupLayer].body.exhibitNo,
      amountFree: state.popup[popupLayer].body.amountFree,
      amountToBuy: state.purchase.amountToBuy,
      asset: state.popup[popupLayer].body.asset,
      asset_longname: state.popup[popupLayer].body.asset_longname,
      priceMona: state.popup[popupLayer].body.priceMona,
      signatureVersion: state.config.clientParameters.signatureVersion.purchase,
      addressCheck: state.addressCheck,
      walletType: state.walletType,
    };
  }
  else {
    stateFixed = {
      purchaseNo: state.purchase.purchaseNo,
      addressMain: state.purchase.addressMain,
      addressPayFrom: state.purchase.addressPayFrom,
      addressSendCardTo: state.purchase.addressSendCardTo,
      addressMainExhibitor: state.itemDetail.item.addressMain,
      exhibitNo: state.itemDetail.item.exhibitNo,
      amountFree: state.itemDetail.item.amountFree,
      amountToBuy: state.purchase.amountToBuy,
      asset: state.itemDetail.item.asset,
      asset_longname: state.itemDetail.item.asset_longname,
      priceMona: state.itemDetail.item.priceMona,
      signatureVersion: state.config.clientParameters.signatureVersion.purchase,
      addressCheck: state.addressCheck,
      walletType: state.walletType,
    };
  }

  // 必須項目チェック
  if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.addressPayFrom === undefined || stateFixed.addressPayFrom === null || stateFixed.addressPayFrom === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouPayFromMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.addressSendCardTo === undefined || stateFixed.addressSendCardTo === null || stateFixed.addressSendCardTo === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouReceiveCardsInMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.amountToBuy === undefined || stateFixed.amountToBuy === null || stateFixed.amountToBuy === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeFilled[state.language] });
    return;
  }

  // 数量チェック
  if (stateFixed.amountToBuy > stateFixed.amountFree) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeWithinTheNumberOfStock[state.language] });
    return;
  }

  if (stateFixed.amountToBuy < 1) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToBuyMustBeEqualOrLargerThan1[state.language] });
    return;
  }

  const tokenName = stateFixed.asset_longname === null ? stateFixed.asset : `${stateFixed.asset_longname}(${stateFixed.asset})`;
  const tokenNameEither = stateFixed.asset_longname === null ? stateFixed.asset : stateFixed.asset_longname;

  devLog('popupLayer', popupLayer);
  devLog('stateFixed', JSON.stringify(stateFixed));

  let signature;

  const clientTime = Date.now();
  const message = `I want to buy ${stateFixed.amountToBuy} ${tokenName}(s), No.${stateFixed.exhibitNo} of ${stateFixed.addressMainExhibitor}, for ${stateFixed.priceMona} MONA per unit. I want to purchase them as ${stateFixed.addressMain}. I will send MONA from ${stateFixed.addressPayFrom}. I want receive token(s) in ${stateFixed.addressSendCardTo}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  // キープールに鍵があるかチェック

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (
    addressType === 'addressMain' && keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined ||
    addressType === 'addressPayFrom' && keyPairsInPool[stateFixed.addressPayFrom]?.keyPair !== undefined
  ) {
    let keyPair;

    if (addressType === 'addressMain') {
      addressActual = stateFixed.addressMain;
      keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    }
    else { // addressPayFrom
      addressActual = stateFixed.addressPayFrom;
      keyPair = keyPairsInPool[stateFixed.addressPayFrom].keyPair;
    }

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    // キーカードのアドレスが合ってるかチェック

    if (stateFixed.addressCheck === 'strict') {
      if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressPayFrom)) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
    }
    else if (stateFixed.addressCheck === 'addressSecond') {
      if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressPayFrom) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
    }
    else { // off
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    // キープールに鍵が無い。
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;
      devLog('address', stateFixed.addressMain, stateFixed.addressPayFrom, addressActual, stateFixed.addressCheck);

      if (stateFixed.addressCheck === 'strict') {
        if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressPayFrom)) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else if (stateFixed.addressCheck === 'addressSecond') {
        if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressPayFrom) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else { // off
        return 'fulfilled';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return;
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    // キーカードのアドレスが合ってるかチェック

    if (stateFixed.addressCheck === 'strict') {
      if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressPayFrom)) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
    }
    else if (stateFixed.addressCheck === 'addressSecond') {
      if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressPayFrom) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
    }
    else { // off
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // bc
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  if (stateFixed.purchaseNo === null || stateFixed.purchaseNo === '') {
    bodyObj = {
      "body": {
        "method": 'insert',
        "addressType": addressType,
        "addressMain": stateFixed.addressMain,
        "addressMainActual": addressActual,
        "addressPayFrom": stateFixed.addressPayFrom,
        "addressSendCardTo": stateFixed.addressSendCardTo,
        "addressMainExhibitor": stateFixed.addressMainExhibitor,
        "exhibitNo": stateFixed.exhibitNo,
        "amountToBuy": stateFixed.amountToBuy,
        // "asset": stateFixed.asset,
        // "asset_longname": stateFixed.asset_longname,
        // "tokenName": tokenName,
        // "priceMona": stateFixed.priceMona,
      }
    };

    bodyObj.body.clientTimeOfAddressMain = clientTime;
    bodyObj.body.signatureByAddressMain = signature;
    bodyObj.body.signatureVersionOfAddressMain = stateFixed.signatureVersion;

    if (stateFixed.addressMain === stateFixed.addressPayFrom || addressActual === stateFixed.addressPayFrom) {
      bodyObj.body.clientTimeOfAddressPayFrom = clientTime;
      bodyObj.body.signatureByAddressPayFrom = signature;
      bodyObj.body.signatureVersionOfAddressPayFrom = stateFixed.signatureVersion;
    }

    request.body = JSON.stringify(bodyObj);
  }
  else {
    bodyObj = {
      "body": {
        "method": 'update',
        "addressMain": stateFixed.addressMain,
        "addressPayFromActual": addressActual,
        "purchaseNo": stateFixed.purchaseNo,
        "addressType": addressType,
      }
    };

    bodyObj.body.clientTimeOfAddressPayFrom = clientTime;
    bodyObj.body.signatureByAddressPayFrom = signature;
    bodyObj.body.signatureVersionOfAddressPayFrom = stateFixed.signatureVersion;

    request.body = JSON.stringify(bodyObj);
  }

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/purchase';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
    "you are not delegated from main address.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "you are not delegated from the address you pay from.": words.norIsTheSignatureDelegatedFromAddressYouPayFrom[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    const purchase = response.body.purchase;
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;

    // purchase情報更新
    dispatch({ type: 'setState', key: 'purchase', value: purchase });

    // session情報更新
    if (addressType === 'addressMain') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId.addressMain, 'expirationOfSession': expirationOfSession.addressMain} });

      if (addressActual !== stateFixed.addressMain) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
      }

      if (sessionId.addressPayFrom !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressPayFrom], value: {'sessionId': sessionId.addressPayFrom, 'expirationOfSession': expirationOfSession.addressPayFrom} });
      }
    }
    else { // addressPayFrom
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressPayFrom], value: {'sessionId': sessionId.addressPayFrom, 'expirationOfSession': expirationOfSession.addressPayFrom} });

      if (addressActual !== stateFixed.addressPayFrom) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressPayFromActual, 'expirationOfSession': expirationOfSession.addressPayFromActual} });
      }
    }

    // オーダーNo.通知欄表示(全署名完了していたら)
    if ( purchase.signatureByAddressMain !== undefined && purchase.signatureByAddressMain !== null && purchase.signatureByAddressMain !== '' &&
         purchase.signatureByAddressPayFrom !== undefined && purchase.signatureByAddressPayFrom !== null && purchase.signatureByAddressPayFrom !== '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.acceptedAsPurchaseNoX1[state.language] + purchase.purchaseNo + words.acceptedAsPurchaseNoX2[state.language] });
    }

    // cookie情報更新(アドレス情報)
    /*
    const exhibitorName = state.usersGeneralIndex[stateFixed.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[stateFixed.addressMainExhibitor].userName : stateFixed.addressMainExhibitor;
    const responseGetBalances = await getBalances(state, dispatch, stateFixed.addressMain);
    devLog('get balances; result', JSON.stringify(responseGetBalances));

    if (responseGetBalances.status !== 'rejected' && responseGetBalances.body[state.config.clientParameters.cookie.addresses.restrainingToken] === undefined) {
      try {
        let addressHistory = cookies.addresses;

        if (addressHistory === undefined) {
          addressHistory = [];
        }

        addressHistory = addressHistory.filter( item => ![stateFixed.addressMain, stateFixed.addressPayFrom, stateFixed.addressSendCardTo].includes(item.address) );
        addressHistory.unshift(
          {
            action: 'purchase',
            addressType: 'addressMain',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            // addressMainExhibitor: stateFixed.addressMainExhibitor,
            // tokenName: tokenNameEither,
            // amount: stateFixed.amountToBuy,
             time: clientTime,
            address: stateFixed.addressMain
          },
          {
            action: 'purchase',
            addressType: 'addressPayFrom',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            // addressMainExhibitor: stateFixed.addressMainExhibitor,
            // tokenName: tokenNameEither,
            // amount: stateFixed.amountToBuy,
             time: clientTime,
            address: stateFixed.addressPayFrom
          },
          {
            action: 'purchase',
            addressType: 'addressSendCardTo',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            // addressMainExhibitor: stateFixed.addressMainExhibitor,
            // tokenName: tokenNameEither,
            // amount: stateFixed.amountToBuy,
            time: clientTime,
            address: stateFixed.addressSendCardTo
          }
        );
        addressHistory = addressHistory.slice(0, state.config.clientParameters.cookie.addresses.maxSize);

        setCookie('addresses', addressHistory, { maxAge: state.config.clientParameters.cookie.addresses.maxAge, secure: true, sameSite: 'strict' });
      }
      catch (err) {
        devLog('failed to set a cookie.', JSON.stringify(err));
      }
    }
    */

    const exhibitorName = state.usersGeneralIndex[stateFixed.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[stateFixed.addressMainExhibitor].userName : stateFixed.addressMainExhibitor;
    const cookiesNew = [
          {
            action: 'purchase',
            addressType: 'addressMain',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPayFrom )) {
      cookiesNew.push(
          {
            action: 'purchase',
            addressType: 'addressPayFrom',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            time: clientTime,
            address: stateFixed.addressPayFrom
          },
      );
    }

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressSendCardTo )) {
      cookiesNew.push(
          {
            action: 'purchase',
            addressType: 'addressSendCardTo',
            description: `${exhibitorName} ${tokenNameEither} ${stateFixed.amountToBuy}`,
            time: clientTime,
            address: stateFixed.addressSendCardTo
          }
      );
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}

// 「購入:MONA送信」ボタン押下 HANDLE CLICK SEND MONA
async function handleClickSendMona(state, dispatch, popupLayer, keyPairs) {
  // let request = {};
  // let response = {};
  let stateFixed = {};
  // let messages = {};
  // let utxos;
  // let utxosSelected;
  // let approximatedTransactionBytes;
  // let feeRate;
  // let transactionFee;
  // let change;
  // let amountToPay;
  // let inputs;
  // let outputs;
  // let unsignedTransaction;
  // let txid;

  // state固定
  if (popupLayer !== undefined && popupLayer !== null) {
    stateFixed = {
      addressPayFrom: state.purchase.addressPayFrom,
      addressPayProceedsTo: state.popup[popupLayer].body.addressPayProceedsTo,
      addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
      monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
      amountToBuy: state.purchase.amountToBuy,
      priceMona: state.popup[popupLayer].body.priceMona,
      priceMonaWatanabe: state.popup[popupLayer].body.priceMonaWatanabe,
      proceedsNetMona: state.popup[popupLayer].body.proceedsNetMona,
      royaltyMona: state.popup[popupLayer].body.royaltyMona,
      feeMona: state.popup[popupLayer].body.feeMona,
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
      transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
      addressMain: state.purchase.addressMain,
      purchaseNo: state.purchase.purchaseNo,
      signatureByAddressMain: state.purchase.signatureByAddressMain,
      walletType: state.walletType,
    };
  }
  else {
    stateFixed = {
      addressPayFrom: state.purchase.addressPayFrom,
      addressPayProceedsTo: state.itemDetail.item.addressPayProceedsTo,
      addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
      monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
      amountToBuy: state.purchase.amountToBuy,
      priceMona: state.itemDetail.item.priceMona,
      priceMonaWatanabe: state.itemDetail.item.priceMonaWatanabe,
      proceedsNetMona: state.itemDetail.item.proceedsNetMona,
      royaltyMona: state.itemDetail.item.royaltyMona,
      feeMona: state.itemDetail.item.feeMona,
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
      transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
      addressMain: state.purchase.addressMain,
      purchaseNo: state.purchase.purchaseNo,
      signatureByAddressMain: state.purchase.signatureByAddressMain,
      walletType: state.walletType,
    };
  }

  const buildConfirmAndBroadcast = async (keyPairsInArg) => {
    let actionItemsMultiSources;

    // まず最初にカートを空にする！

    actionItemsMultiSources = deleteCart(state, dispatch, 'cartMona');

    const amountProceedsWatanabe = decimalAdjust( 'floor', new decimal(stateFixed.proceedsNetMona).times(stateFixed.amountToBuy).toNumber(), 0 ); 

    actionItemsMultiSources = addSendsToTheCartMona(
      state, dispatch, stateFixed.addressPayFrom, stateFixed.addressPayProceedsTo, amountProceedsWatanabe, actionItemsMultiSources
    );

    if (stateFixed.royaltyMona > 0) {
      const amountRoyaltyWatanabe = decimalAdjust( 'floor', new decimal(stateFixed.royaltyMona).times(stateFixed.amountToBuy).toNumber(), 0 ); 

      actionItemsMultiSources = addSendsToTheCartMona(
        state, dispatch, stateFixed.addressPayFrom, stateFixed.addressPayRoyaltyTo, amountRoyaltyWatanabe, actionItemsMultiSources
      );
    }

    const amountServiceFeeWatanabe = decimalAdjust( 'floor', new decimal(stateFixed.feeMona).times(stateFixed.amountToBuy).toNumber(), 0 ); 

    actionItemsMultiSources = addSendsToTheCartMona(
      state, dispatch, stateFixed.addressPayFrom, stateFixed.monacottoAddressMona, amountServiceFeeWatanabe, actionItemsMultiSources
    );

    for (const addressFrom of Object.keys(actionItemsMultiSources)) {
      for (const actionItem of actionItemsMultiSources[addressFrom]) {
        actionItem.status = 'unprocessed';
      }
    }

    dispatch({ type: 'setState', key: 'accessing', value: true });

    await buildMonaTransactions(
      state, dispatch, keyPairsInArg, actionItemsMultiSources,
      {
        provisionalTransactionFee: new decimal(stateFixed.provisionalTransactionFee).times(100000000).toNumber(),
        transactionFeeUpperBound: stateFixed.transactionFeeUpperBound,
      }
    );

    dispatch({ type: 'setState', key: 'accessing', value: false });

    if (actionItemsMultiSources[stateFixed.addressPayFrom][0].status === 'succeeded') {
    }
    else { // failed
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
      return { status: 'rejected' };
    }

    confirmCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSources, stateFixed);
  };


  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (keyPairsInPool[stateFixed.addressPayFrom]?.keyPair !== undefined) {
    buildConfirmAndBroadcast(keyPairsInPool);
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let addressActual;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    // キーカードのアドレスが合ってるかチェック

    if (addressActual !== stateFixed.addressPayFrom) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
      return 'rejected';
    }

    buildConfirmAndBroadcast({ [addressActual]: { keyPair: keyPair } });
  }
  else if (stateFixed.walletType === 'mpurse') {
    // Mpurseが接続されているかチェック
    if (window.mpurse === undefined) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.activateMpurse[state.language] });
      return { status: 'rejected' };
    }

    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( result => {
      if (result !== stateFixed.addressPayFrom) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
      else {
        return 'fulfilled';
      }
    })
    .catch( error => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    buildConfirmAndBroadcast();
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] + 'NFC' });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] + 'NFC' });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // bc
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }
}

// 「購入:デフォルト」ボタン押下
async function handleClickDefaultPurchase(state, dispatch) {
  if (state.purchase.addressMain !== undefined && state.purchase.addressMain !== '') {
    if (state.user[state.purchase.addressMain] !== undefined && state.user[state.purchase.addressMain].basicInformation !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressPayFrom'], value: state.user[state.purchase.addressMain].basicInformation.addressPayFromDefault });
      dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressSendCardTo'], value: state.user[state.purchase.addressMain].basicInformation.addressSendCardToDefault });
    }
    else {
    }
  }
  else if (state.login.addressMain !== undefined && state.login.addressMain !== '') {
    if (state.user[state.login.addressMain] !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressMain'], value: state.login.addressMain });

      if (state.user[state.login.addressMain].basicInformation !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressPayFrom'], value: state.user[state.login.addressMain].basicInformation.addressPayFromDefault });
        dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressSendCardTo'], value: state.user[state.login.addressMain].basicInformation.addressSendCardToDefault });
      }
    }
    else {
    }
  }
  else {
  }

  return;
}

// 「購入:クリア」ボタン押下 HANDLE CLICK CLEAR PURCHASE
async function handleClickClearPurchase(state, dispatch) {
  dispatch({ type: 'setState', key: 'purchase',
    value: {
      purchaseNo: null,
      addressMain: '',
      addressPayFrom: '',
      addressSendCardTo: '',
      addressMainExhibitor: '',
      exhibitNo: '',
      amountToBuy: 1,
      signatureByAddressMain: '',
      signatureByAddressPayFrom: '',
      addressPayRoyaltyTo: null,
      disabled: false,
      status: 'waitingForSignature',
    }
  });

  return;
}

// 「クリエイター情報編集」ボタン押下 HANDLE CLICK EDIT CREATOR INFORMATION
async function handleClickEditCreatorInformation(state, dispatch, asset, { keyPairs } = {}) {
  let addressMainActual;
  let signature;
  let request = {};
  let messages = {};
  let result;
  let keyPair;

  // state固定
  const stateFixed = {
    // addressMain: state.cardRegistration.addressMain,
    creater: state.creatorInformation.creater,
    createrText: state.creatorInformation.createrText,
    monacottoAddressMain: state.creatorInformation.monacottoAddressMain,
    createrLink: state.creatorInformation.createrLink,
    // imageMain: state.cardRegistration.imagesNew.main,
    signatureVersion: state.config.clientParameters.signatureVersion.editCreatorInformation,
    // addressCheck: state.addressCheck,
  };

  // 必須項目チェック
  if (asset === undefined || asset === null || asset === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.assetMustBeFilled[state.language] });
    return;
  }

  // // 文字数チェック
  // if (stateFixed.name.length > 25) {
  //   dispatch({ type: 'setNotification', key: 'notification', value: words.nameIsTooLong[state.language] });
  //   return;
  // }

  // if (stateFixed.feature.length > 70) {
  //   dispatch({ type: 'setNotification', key: 'notification', value: words.featureIsTooLong[state.language] });
  //   return;
  // }

  // アドレスは入力させていないので、ノーチェックで署名する。
  const clientTime = Date.now();

  if (keyPairs !== undefined && keyPairs !== null) {
    let result;

    keyPair = keyPairs[0];
    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressMainActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return result;
    }

    // 署名
    const message = `I edit the creator information of ${asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else {
    result = await window.mpurse.getAddress()
    .then( (result) => {
      addressMainActual = result;

      // if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
      //   if (addressMainActual !== stateFixed.addressMain) {
      //     dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
      //     return 'rejected';
      //   }
      //   else {
      //     return 'fulfilled';
      //   }
      // }
      // else { // off
      //   return 'fulfilled';
      // }

      return 'fulfilled';
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    const message = `I edit the creator information of ${asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = await window.mpurse.signMessage(message)
    .then( result => {
      signature = result;
      return 'fulfilled';
    })
    .catch( err => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }
  }

  const formData = new FormData();

  const requestJson = JSON.stringify({
    body: {
      addressMain: addressMainActual,
      addressMainActual: addressMainActual,
      asset: asset,
      creater: stateFixed.creater,
      createrText: stateFixed.createrText,
      monacottoAddressMain: stateFixed.monacottoAddressMain,
      createrLink: stateFixed.createrLink,
      clientTime : clientTime,
      signature : signature,
      signatureVersion : stateFixed.signatureVersion,
    }
  });

  formData.append('json', requestJson);

  // if (stateFixed.imageMain !== undefined && stateFixed.imageMain !== null) {
  //   formData.append('imageMain', stateFixed.imageMain, stateFixed.imageMain.name);
  // }

  request.body = formData;
  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/edit_creator_information';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "signature by asset owner is required.": words.signatureByAssetOwnerIsRequired[state.language],
    // "asset is required; not asset_longname.": words.assetIsRequiredNotAssetLongname[state.language],
    // "you are not delegated.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    // "addressMainActual must be filled.": words.clearYourBrowserOrAppCache[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
      value: {'sessionId': response.body.sessionId.addressMain, 'expirationOfSession': response.body.expirationOfSession.addressMain} });

    // if (addressMainActual !== stateFixed.addressMain) {
    //   dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
    //     value: {'sessionId': response.body.sessionId.addressMainActual, 'expirationOfSession': response.body.expirationOfSession.addressMainActual} });
    // }

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'setUp',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: clientTime,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    // -- 登録カード情報取得
    getRegisteredCard(state, dispatch);
  }
  else {
  }

  return response;
}

export {
  handleClickSendMona,
  handleClickSignPurchase,
  handleClickDefaultPurchase,
  handleClickClearPurchase,
  handleClickEditCreatorInformation,
};
